export enum ApplyPremiumFlagEnum {
  None = 0,
  PostcodePremium = 1,
  PostcodeUplift = 2,
  TimeWindow = 4,
  Checklist = 8,
}
